require('./angular-route');
module.exports = 'ngRoute';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-route/index.js
 ** module id = 23
 ** module chunks = 0
 **/